export default {
    imageAIFormRules: {
        enterDescription: 'Syötä kuvaus',
        invalidDescription: 'Syötä voimassa oleva kuvaus',
        enterNumberOfVariations: 'Valitse vaihtoehtojen määrä, kiitos',
        invalidNumberOfVariations: 'Voit luoda enintään 4 ja vähintään 1 vaihtoehtoa',
        enterStyle: 'Valitse vähintään yksi tyyli, kiitos',
    },
};
